<h2 class="mb-1">{{ 'commercialCheckout.personalization.multiplePersons.title' | transloco }}</h2>
<p class="mbottom-12 text-sm text-n-60">{{ 'commercialCheckout.personalization.multiplePersons.subtitle' | transloco: { numberOfPersons: maxNumberOfPersons$ | async } }}</p>
<form [formGroup]="multiplePersonForm" (yatSubmit)="submitForm($event)">
  <div formArrayName="persons" *yatVar="(firstPerson$ | async) as firstPerson">
    <yat-selected-person-card id="e1696845-3aa0-4afe-ba65-b3015f3447df" [persons]="firstPerson ? [firstPerson] : []" [showIcon]="false" (cardSelect)="editFirstPerson()"></yat-selected-person-card>
    <div *ngFor="let person of persons.controls; let i = index" class="form-row participant-name">
      <div class="form-group col-12 no-label mb-0">
        <div class="input-group">
          <input
            type="text"
            maxlength="255"
            [formControlName]="i"
            [placeholder]="'commercialCheckout.personalization.multiplePersons.placeholder' | transloco: { number: i + 2 }"
            (focus)="focused = i"
            (focusout)="focused = null"
            yatInput />
            <span class="input-group-append" yatTabSelectable (tabSelect)="removePerson(i)">
              <yat-icon id="d7ebcc96-f877-460e-8ed6-548ce3404cb2" name="delete-duo" (focus)="focused = i" (focusout)="focused = null"> </yat-icon>
            </span>
          <div *ngIf="person.invalid && person.touched" class="invalid-feedback" [ngSwitch]="person.errors | classifyValidationError">
            <span *ngSwitchCase="'required'">{{ 'commercialCheckout.personalization.multiplePersons.nameRequiredError' | transloco }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-12 mb-2 pb-1">
      <a yat-link *ngIf="persons && persons.length < ((maxPersons$ | async) ?? 0)" type="button" class="link link-secondary" (click)="addPerson()">
        <yat-icon id="9f9406f7-fa1a-4ecf-bd07-876cbb7980cc" name="plus-circle-duo" class="mr-1" />{{ 'commercialCheckout.personalization.multiplePersons.add' | transloco }}
      </a>
    </div>
  </div>
  <div class="mbottom-12">
    <yat-buttons
    [primaryButtonName]="('saveAndContinue' | commonWording | async) ?? ''"
    [useYatAutoSpinner]="setAdditionalPersonsActionFilter"
    [secondaryButtonName]="('cancel' | commonWording | async) ?? ''"
    (secondaryButtonClickMethod)="cancel()"
    [className]="'btn-large'">
  </yat-buttons>
  </div>
</form>
